/*
 * @author Charles Xie
 */

export class LabeledData {

  data: any;
  label: string;

  constructor(data: any, label: string) {
    this.data = data;
    this.label = label;
  }

}
